import styled from '@emotion/styled'

const EditBucketFormContainer = styled.div`
  padding: 14px;
`

export {
  EditBucketFormContainer
}